export default __webpack_public_path__ + "static/media/wantai-logo.61f16f79.png";